module.exports = __webpack_public_path__ + "img/gramelsberger.6550072c.png";